export const SET_CURRENT_CAPTAINS = 'SET_CURRENT_CAPTAINS';

export const actionSetCurrentCaptains = captains => ({
    type: SET_CURRENT_CAPTAINS,
    payload: captains
})
